import React from "react";

export const TESTING_ACCOUNT_FILTER_DEFAULT = "hide";

export const TESTING_ACCOUNT_FILTER_OPTIONS = [
  { value: "hide", label: "Hide Testing" },
  { value: "all", label: "Show All" },
  { value: "testing", label: "Testing Only" },
];

export const getTestingAccountFilterLabel = (value) => {
  const option = TESTING_ACCOUNT_FILTER_OPTIONS.find((item) => item.value === value);
  return option?.label || TESTING_ACCOUNT_FILTER_OPTIONS[0].label;
};

const TestingAccountFilter = ({
  value = TESTING_ACCOUNT_FILTER_DEFAULT,
  onChange,
  name = "testing_account_filter",
  className = "col-md-3 form-group",
  label = "Account Type",
}) => (
  <div className={className}>
    <label>{label}</label>
    <select
      className="form-control"
      name={name}
      value={value || TESTING_ACCOUNT_FILTER_DEFAULT}
      onChange={onChange}
    >
      {TESTING_ACCOUNT_FILTER_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export default TestingAccountFilter;
